import * as runtime from '@/api/runtime'
import {
  BatchTrcAuthorityUpdateRequest,
  BatchTrcAuthorityUpdateRequestToJSON,
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api/models/batch'
import {
  BatchTrcAuthorityUpdateCondition,
  BatchTrcAuthorityUpdateConditionFromJSON
} from '@/api/models/batch/BatchTrcAuthorityUpdateCondition'

/**
 * 帳票作成
 */
export class BatchTrcAuthorityUpdateApi extends runtime.BaseAPI {
  async register(request: BatchTrcAuthorityUpdateRequest): Promise<number> {
    const response = await this.requestPost(
      `/batch/bibliography/trc-authority-update`,
      BatchTrcAuthorityUpdateRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async getInitialCondition(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchTrcAuthorityUpdateCondition> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchTrcAuthorityUpdateConditionFromJSON(jsonValue)
    ).value()
  }
}
